"use strict";
var React = require("react");
var AddInventoryModal = require("./AddInventoryItemFormModal");
var EditInventoryItemModal = require("./EditInventoryItemFormModal.js");
var DeleteInventoryItemModal = require("./DeleteInventoryItemFormModal.js");
var ItemHistoryStore = require("../../stores/ItemHistoryStore");
var ItemHistoryActions = require("../../actions/ItemHistoryActions");
var InventoryActions = require("../../actions/InventoryActions")
var _ = require("underscore");
var moment = require("moment");
var clone = require("clone");
var numberWithCommas = require('../../utils/helpers').numberWithCommas;
var CompanyStore = require("../../stores/CompanyStore");
var ReactDOM = require('react-dom');
import { GoogleMapLoader, GoogleMap, Marker } from "react-google-maps";
import MapIcon from '../../../images/icons/map-location.png';


var InventoryItemDetail = React.createClass({
    getInitialState: function() {
      const index = _.findLastIndex(CompanyStore.getState().locations, {
        id: this.props.equipment.location,
      });

      let location = CompanyStore.getState().locations[index];
      // If the location is not set we set the location to Tortola
      if (!location || location.latitude === '0.000000') { location = { latitude: 18.432786, longitude: -64.633258 }; }
      return { location: location };
    },
    render: function() {
        var equipment = this.props.equipment;
        var user_list = _.indexBy(CompanyStore.getState().users, 'id');
        return (
          <div className="item-details-wrapper">
            <div className="row">
              <div className="col-lg-12">
                <div className="item-details-wrapper-body">
                  <div className="item-content">
                    <div className="item-header">
                      <div>
                        <h1>{equipment.brand_name ? equipment.brand_name : " "}</h1>
                        <h1 className="bold">{equipment.name ? equipment.name : " "}</h1>
                        <h2>{equipment.type_name ? equipment.type_name : " "}</h2>
                      </div>
                      <h1 className="bold">{equipment.purchase_price ? numberWithCommas(parseInt(equipment.purchase_price))+" kr." : " "}</h1>
                    </div>

                    <div className="item-description">
                      {equipment.description ? equipment.description : " "}
                    </div>

                    <div className="item-column-wrapper">
                      <div className="clearfix">
                        <div className="item-column">

                          <div className="item-details">
                            <div className="item-label">Deild</div>
                            <div className="item-value">{equipment.department_name ? equipment.department_name : " "}</div>
                          </div>

                          {(equipment.home_use) &&
                            <div className="item-details">
                              <div className="item-label">Heimabúnaður skráður á</div>
                              <div className="item-value">{user_list[equipment.user] ? user_list[equipment.user].first_name : ''} {user_list[equipment.user] ? user_list[equipment.user].last_name : ''} <small className="text-muted">({user_list[equipment.user] ? user_list[equipment.user].username : ''})</small></div>
                            </div>
                          }

                          {(equipment.purchase_date) &&
                            <div className="item-details">
                              <div className="item-label">Kaupdagur</div>
                              <div className="item-value">{equipment.purchase_date ? moment(equipment.purchase_date).format('DD MMM YYYY') : " "}</div>
                            </div>
                          }
                          <div className="item-details">
                            <div className="item-label">Kaupverð</div>
                            <div className="item-value">{numberWithCommas(parseInt(equipment.purchase_price))} kr.</div>
                          </div>

                          {(equipment.location_name) &&
                            <div className="item-details">
                              <div className="item-label">Staðsetning</div>
                              <div className="item-value">{equipment.location_name}</div>
                            </div>
                          }

                        </div>
                      </div>
                      <hr/>
                      <div className="clearfix">
                        <div className="item-column">

                          {(equipment.internal_cost) &&
                            <div className="item-details">
                              <div className="item-label">Innri kostnaður</div>
                              <div className="item-value">{numberWithCommas(parseInt(equipment.internal_cost))} kr.</div>
                            </div>
                          }

                          {(equipment.serial_number) &&
                            <div className="item-details">
                              <div className="item-label">Raðnúmer</div>
                              <div className="item-value">{equipment.serial_number}</div>
                            </div>
                          }

                          {(equipment.local_number) &&
                            <div className="item-details">
                              <div className="item-label">Auðkennisnúmer</div>
                              <div className="item-value">{equipment.local_number}</div>
                            </div>
                          }

                          {(equipment.account_key) &&
                          <div className="item-details">
                            <div className="item-label">Bókhaldslykill</div>
                            <div className="item-value">{equipment.account_key}</div>
                          </div>
                          }

                          {(equipment.barcode) &&
                            <div className="item-details">
                              <div className="item-label">Strikamerki</div>
                              <div className="item-value">{equipment.barcode}</div>
                            </div>
                          }

                          {(equipment.nfc_tag) &&
                          <div className="item-details">
                            <div className="item-label">NFC lykill</div>
                            <div className="item-value">{equipment.nfc_tag}</div>
                          </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item-map">
                    <div className="location-label-wrapper">
                      <div className="location-label">
                        {equipment.location_name}
                      </div>
                    </div>
                    <GoogleMapLoader
                       containerElement={
                         <div
                           style={{ height: '100%' }}
                         />
                       }
                       googleMapElement={
                         <GoogleMap
                           defaultZoom={15}
                           center={{
                             lat: parseFloat(this.state.location ? this.state.location.latitude : 18.432786),
                             lng: parseFloat(this.state.location ? this.state.location.longitude : -64.633258)
                           }}
                           defaultOptions={{ disableDefaultUI: true }}
                         >
                          <Marker
                            position={{
                              lat: parseFloat(this.state.location ? this.state.location.latitude : 18.432786),
                              lng: parseFloat(this.state.location ? this.state.location.longitude : -64.633258)
                            }}
                            icon={MapIcon}
                          />
                         </GoogleMap>
                       } />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
});

var TimelineItem = React.createClass({
    render: function() {
        var item = this.props.item;
        var itemDescription = item.text;
        var itemUser = item.owner_username;
        // var momentDate = moment(this.props.item.date);
        // var formattedMomentTime = momentDate.format("HH:mm");
        var momentDate = moment();
        var formattedMomentTime = momentDate.format("HH:mm");
        var formattedMomentDate = momentDate.format("MMM DD, YYYY");

        return (
            <div  className="timeline-item">
                <div className="timeline-header">
                    <div className="timeline-title">{formattedMomentDate}</div>
                </div>
                <div className="timeline-body">
                  <ul>
                      <li>
                          <span>{itemDescription}</span>
                          <div className="timeline-info">
                              <span className="md md-access-time"/> {formattedMomentTime}<br/>
                              <span className="md md-account-circle"/> {itemUser}
                          </div>
                      </li>
                  </ul>
              </div>
            </div>
        );
    }
});

var InventoryItem = React.createClass({
    historyItemCount: 0,
    getInitialState(){
        var itemChanges = ItemHistoryStore.getState();
        var filteredItemList = _.filter(itemChanges.allChanges, {"uuid": this.props.equipment.id});
        return {
            showDeleteModal: false,
            showEditModal: false,
            showAddModal: false,
            // changes: filteredItemList,
            changes: this.props.equipment.comments,
            historyItemLimit: 3,
            historyItemCount: 0,
            showCommentInput: false
        };
    },
    componentDidMount() {
        // ItemHistoryStore.listen(this.onChange);
    },
    componentWillUnmount() {
        // ItemHistoryStore.unlisten(this.onChange);
    },
    componentDidUpdate(prevProps, prevState) {
      if(this.state.showCommentInput){
        ReactDOM.findDOMNode(this.refs.commentInput).focus();
      }
    },
    onChange() {
        // this.setState(this.getInitialState());
    },
    closeDelete(){
        this.setState({ showDeleteModal: false });
    },
    openDelete(){
        this.setState({ showDeleteModal: true });
    },
    closeEdit(){
        this.setState({ showEditModal: false });
    },
    openEdit(){
        this.setState({ showEditModal: true });
    },
    closeAdd(){
        this.setState({ showAddModal: false });
    },
    openAdd(){
        this.setState({ showAddModal: true });
    },
    mapTimeLineItems(item) {
        // =======================
        // Not neccessary for v1.0
        // =======================
        this.historyItemCount += 1;

        return (
          <div key={item.id} >
            {this.historyItemCount <= this.state.historyItemLimit ?
              <TimelineItem item={item} />
            : null}
          </div>
        )
    },
    showMoreItems() {
        // =======================
        // Not neccessary for v1.0
        // =======================
        var limit = clone(this.state.historyItemLimit);
        var newLimit = limit+5;
        var newState = {
            historyItemLimit: newLimit
        }
        this.setState(newState);
    },
    _handleSubmit(e) {
      if(e.key === 'Enter') {
        this.onSubmit();
      } else {
        ReactDOM.findDOMNode(this.refs.commentInput).focus();
      }
    },
    onSubmit() {
      var r = confirm("Viltu senda inn athugasemdina?");
      if(r == true) {
        var data = {
          "text": ReactDOM.findDOMNode(this.refs.commentInput).value,
          "item": this.props.equipment.id
        }
        InventoryActions.commentOnItem(data);
      } 
    },
    toggleCommentInput() {
      this.setState({ showCommentInput: true });
    },
    render: function() {
        var id = "inventoryItem" + this.props.forId;

        var sortedList = this.state.changes.sort(function(a, b) {
            return moment(a.date) - moment(b.date);
        })

        // Reset counter
        this.historyItemCount = 0;

        var created_date = moment(this.props.equipment.creation_date).format('DD MMM YYYY');
        var created_time = moment(this.props.equipment.creation_date).format('HH:mm');

        return (
            <div className="InventoryItem fullheight" id={id}>
                <InventoryItemDetail
                  equipment={this.props.equipment}
                />
                {(!this.props.isMarket) &&
                <div className="clearfix comment-input-wrapper">
                  {(this.state.showCommentInput) ?
                  <div className="row">
                    <div className="col-md-10">
                      <input type="text" className="input-lg form-control" ref="commentInput" placeholder="Skráðu þína athugasemd hér" onKeyPress={this._handleSubmit} />
                    </div>
                    <div className="col-md-2">
                      <button className="btn btn-primary btn-lg btn-block" onClick={this.onSubmit}>Skrá</button>
                    </div>
                  </div>
                  :
                  <div className="row">
                    <div className="col-md-offset-4 col-md-4">
                      <button className="btn btn-default btn-block" onClick={this.toggleCommentInput}>Skrá athugasemd</button>
                    </div>
                  </div>
                  }
                </div>
                }
                <div className="clearfix timeline-wrapper">
                    <div className="timeline">
                        {_.map(this.state.changes, this.mapTimeLineItems)}
                        {this.historyItemCount > this.state.historyItemLimit ?
                            <div className="timeline-show-more">
                                <span className="show-more-history" onClick={this.showMoreItems.bind(null, this)}>Sýna fleiri</span>
                            </div>
                        : null}
                        <div  className="timeline-item">
                            <div className="timeline-header">
                                <div className="timeline-title">{created_date}</div>
                            </div>
                            <div className="timeline-body">
                                <ul>
                                    <li>
                                        <span>Búnaður stofnaður</span>
                                        <div className="timeline-info">
                                            <span className="md md-access-time"/> {created_time}<br/>
                                            <span className="md md-account-circle"/> {this.props.equipment.created_by_user}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {(this.props.allowEdit && !this.props.allowDelete && !this.props.isMarket) &&
                <div className="item-details-wrapper-footer text-center">
                  <small><strong>ATH:</strong> Notandinn þinn hefur ekki réttindi til að <strong>eyða</strong> þessum búnaði.<br/> Vinsamlegast hafðu samband við stjórnanda ef þú telur þig þurfa að breyta þessum búnaði.</small>
                </div>
                }
                {(!this.props.allowEdit && !this.props.allowDelete && !this.props.isMarket) &&
                <div className="item-details-wrapper-footer text-center">
                  <small><strong>ATH:</strong> Notandinn þinn hefur ekki réttindi til að <strong>breyta né eyða</strong> þessum búnaði.<br/> Vinsamlegast hafðu samband við stjórnanda ef þú telur þig þurfa að breyta þessum búnaði.</small>
                </div>
                }
            </div>
        );
    }
});

module.exports = InventoryItem;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/InventoryItem.react.js